import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
import {
  getApplicantsSuccessAction,
  setApplicantsIsLoadingAction,
  setApplicantsCountAction,
  deleteApplicantSuccessAction,
  getApplicantSuccessAction,
  createApplicantSuccessAction,
  updateApplicantSuccessAction,
} from './Actions';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../notifications/Actions';
import * as api from './Api';
import { setRedirectFalse, setRedirectTrue} from '../globalFail/Action';
import { push } from 'connected-react-router';

function* createApplicant({ payload, noRedirect }) {
  yield put(setRedirectFalse())
  try {
    yield put(setApplicantsIsLoadingAction(true));
    const response = yield call(api.createApplicant, payload);

    const { data } = response;
    const applicant = data;
    yield put(createApplicantSuccessAction(applicant));
    yield put(newSuccessNotificationAction('Applicant Created'));
    yield put(setRedirectTrue())
    // if (!noRedirect) {

    //   yield put(push('/applicants'));
    // }
  } catch (error) {
    yield put(errorNotificationFromError(error));
    yield put(setRedirectFalse())
  } finally {
    yield put(setApplicantsIsLoadingAction(false));
  }
}

function* updateApplicant({ payload }) {
  const { formData, id } = payload;

  try {
    yield put(setApplicantsIsLoadingAction(true));
    const response = yield call(api.updateApplicant, id, formData);
    const { data } = response;
    console.log(formData);
    yield put(updateApplicantSuccessAction(data));
    yield put(newSuccessNotificationAction('Applicant Updated'));
    // yield put(push('/applicants'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantsIsLoadingAction(false));
  }
}

function* getApplicant({ payload }) {
  const applicantId = payload;

  try {
    yield put(setApplicantsIsLoadingAction(true));
    const response = yield call(api.getApplicant, applicantId);
    const { data } = response;
    const applicant = data;
    yield put(getApplicantSuccessAction(applicant));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantsIsLoadingAction(false));
  }
}

function* deleteApplicant({ payload }) {
  try {
    yield put(setApplicantsIsLoadingAction(true));
    yield call(api.deleteApplicant, payload);

    yield put(deleteApplicantSuccessAction(payload));
    yield put(newSuccessNotificationAction('Applicant Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantsIsLoadingAction(false));
  }
}

//





function* getApplicants({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [],
    filterCountry: '',
    dir: 'asc',
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setApplicantsIsLoadingAction(true));
    const response = yield call(api.getApplicants, body);

    const { data } = response;
    console.log(data);
    const count = data.count;
    const applicants = data.content;
    // const count = data.count;
    // const applicants = data.content
    yield put(setApplicantsCountAction(count));
    yield put(getApplicantsSuccessAction(applicants));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantsIsLoadingAction(false));
  }
}



export default function*() {
  yield takeLatest(actions.UPDATE_APPLICANT, updateApplicant);
  yield takeLatest(actions.CREATE_APPLICANT, createApplicant);
  yield takeLatest(actions.GET_APPLICANT, getApplicant);
  yield takeLatest(actions.DELETE_APPLICANT, deleteApplicant);
  yield takeLatest(actions.GET_APPLICANTS, getApplicants);
  
}